// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__16dvP","tab":"Tabs_tab__3O01v","tabActive":"Tabs_tabActive__1oTDL"};